var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main print-no-padding"},[_vm._m(0),_c('breadcrumb',{attrs:{"firstName":"职员管理"}}),_c('shop-content',{attrs:{"type":2}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"is-print-hide title-area"},[_c('span',{staticClass:"main-title"},[_vm._v("查看职员")])])
}]

export { render, staticRenderFns }